import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { message } from "antd";
import { v4 as uuidv4 } from 'uuid'; // ✅ moved here


export const formatDate = (input)  => {
  const date = new Date(input);
  return date.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

export const handleFileUpload = async (file, type, subjectId) => {
  if (!file) {
    message.error('No file selected.');
    return;
  }

  if (file.size > 10 * 1024 * 1024) {
    message.error('File size must be less than 10 MB.');
    return;
  }

  const allowedTypes = [
    'application/pdf',
    'application/msword', // .doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/gif'
  ];

  if (!allowedTypes.includes(file.type)) {
    message.error('Only PDF, DOC, DOCX, and Image files are allowed.');
    return;
  }


  try {
    const downloadURL = await uploadFileToFirebase(file, type, subjectId);
    if (downloadURL) {
      return downloadURL
    }
  } catch (err) {
    message.error('File upload failed.');
  } 
};

  


const uploadFileToFirebase = async (file, type) => {
  const storage = getStorage();

  // Get file extension
  const ext = file.name.split('.').pop();

  // Create a unique filename
  const uniqueFileName = `${uuidv4()}.${ext}`;

  // Optionally organize by type folder (e.g., 'materials/', 'assignments/')
  const filePath = `${type}/${uniqueFileName}`;
  const fileRef = ref(storage, filePath);

  const snapshot = await uploadBytes(fileRef, file, {
    contentType: file.type
  });

  const downloadURL = await getDownloadURL(snapshot.ref);
  return downloadURL;
};

  